import { css } from "@emotion/react";

export const centered = css`
  text-align: center;
`;

export const backButtonWrapper = css`
  text-align: left;
  width: 100%;
`;

export const careContinuityWrapper = css`
  max-width: 504px;
  margin: 0 auto 16px auto;
  text-align: center;
`;
